import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
/* 들여온 부품(Arc)의 토큰이 먼저 깔리고, 우리 토큰이 그 위에 덮는다 — 같은 뜻의 값이
   두 벌 있을 때 어느 쪽이 이기는지를 순서 하나로 못박아 둔다. */
import "@/components/arc/foundation.css";
import "./styles.css";
import "./styles/arc-overrides.css";
import { updateTabletPwaHead } from "./tabletPwa";
import { locationChangeEvent } from "./pageNavigation";

const syncTabletPwa = () => updateTabletPwaHead(document, window.location.pathname);
syncTabletPwa();
window.addEventListener(locationChangeEvent, syncTabletPwa);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
  });
}
